// ─── Single source of truth: user_type → dashboard URL ───────────────────────
export const DASHBOARD_ROUTES: Record<string, string> = {
  adminstore:     '/adminstore/dashboard/mes-stores',
  superadmin:     '/admin/dashboard',
  store_employee: '/employee/dashboard',
};

export function getDashboardRoute(userType: string): string {
  return DASHBOARD_ROUTES[userType] ?? '/';
}

// ─── URL prefix → required user_type for that section ────────────────────────
// Order matters: more-specific prefixes must come before shorter ones.
export const rolePathMap: Record<string, string> = {
  '/adminstore':  'adminstore',
  '/admin':       'superadmin',
  '/employee':    'store_employee',
};

export interface AccessCheckResult {
  isProtected: boolean;
  allowed: boolean;
  redirectUrl?: string;
}

export function checkPathAccess(pathname: string, userType?: string): AccessCheckResult {
  const isProtected =
    Object.keys(rolePathMap).some(prefix => pathname.startsWith(prefix)) ||
    pathname.startsWith('/profile');

  if (!isProtected) {
    return { isProtected, allowed: true };
  }

  if (!userType) {
    return { isProtected, allowed: false };
  }

  for (const [prefix, requiredType] of Object.entries(rolePathMap)) {
    if (pathname.startsWith(prefix)) {
      if (userType !== requiredType) {
        return {
          isProtected,
          allowed: false,
          redirectUrl: getDashboardRoute(userType),
        };
      }
      break;
    }
  }

  return { isProtected, allowed: true };
}
